import { FC, useEffect } from 'react';

interface Props {
    message: string;
    type: 'error' | 'success';
    onHide: () => void;
}

const MessageToastComponent: FC<Props> = ({ message, type, onHide }) => {
    useEffect(() => {
        if (message) {
            setTimeout(() => {
                onHide();
            }, 3000);
        }
    }, [message]);

    if (message) {
        return (
            <div className={`messageContainerReact`}>
                <div className={`messageContent ${type}`}>
                    <div className="innerContent">
                        <svg className="icon icon-close" aria-hidden="true" focusable="false" onClick={onHide}>
                            <use href="#icon-close"></use>
                        </svg>
                        <p>{message}</p>
                        <div className="round-time-bar" data-style="smooth">
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default MessageToastComponent;
